<template lang="pug">
  app-layout.content-center
    v-container
      v-layout
        v-flex
          div.mb-4.text-xs-center
            p.title-content You have now been successfully unsubscribed from
              br
              | LionDesk daily emails.
            div.py-4.subtitle To re-enable daily emails, go to your  #[a(href='/profile') #[strong User Profile]] and click `Yes` next to Alerts > Send me my LionDesk daily activity email
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'UnsubscribeEmail',
  async mounted(){
    await this.updateDailyEmail(false);
  },
  methods: {
    ...mapActions('userInformation', ['getUser', 'updateDailyEmail']),
  }
}
</script>
<style lang="scss" scoped>
  .content-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .title-content {
    font-weight: 200;
    font-size: 32px;
  }
</style>